import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme/theme';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Expertise from './components/Expertise/Expertise';
import Projects from './components/Projects/Projects';
import WhyUs from './components/WhyUs/WhyUs';
import Footer from './components/Footer/Footer';
import Ads from './components/Ads/Ads';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Header />
      <Hero />
      <Expertise />
      <Projects />
      <WhyUs />
      <Ads />
      <Footer />
    </ThemeProvider>
  );
}

export default App;
